import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { _Api } from "./api/_call";
import SaleHistory from "./Modals/SaleHistoryModal";

// Parked sales icon for the POS screen's normal panel (the blank panel has its own in CheckoutBlank).
// Change refreshKey after a recall to reload the count and the park list.
const ParkHistoryButton = ({ park_id, setpark_id, refreshKey }) => {
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const [parkcount, setParkcount] = useState(0);

  useEffect(() => {
    const getParkCount = async () => {
      try {
        const res = await _Api({}, `api/v1/POS/park/getParkCount`);
        if (res.code === 200) {
          setParkcount(res?.data);
        }
      } catch (err) {
        console.log(err, "err");
      }
    };
    getParkCount();
  }, [refreshKey]);

  if (!(parkcount > 0) || generalsettings?.data?.generalsetup?.isPark !== "1") {
    return null;
  }

  return (
    <>
      <div
        className="sale-history-btn"
        style={{ position: "relative", bottom: 0, marginBottom: "0.5vw" }}
        data-bs-toggle="modal"
        data-bs-target="#sale-history-Modal"
      >
        <img
          className="sale-history-btn-img"
          src={base_assets + "images/pos/icons/timer-icon.png"}
          alt=""
        />
        <span className="sale-history-btn-num">{parkcount}</span>
      </div>
      <SaleHistory
        key={refreshKey}
        park_id={park_id}
        setpark_id={setpark_id}
        frompos={true}
      />
    </>
  );
};

export default ParkHistoryButton;
